import React, { Component } from 'react';
import {Form, Control, Errors} from 'react-redux-form';
import {formatMoney} from "accounting-js";
import _ from 'lodash';
import BigFileUpload from "../widgets/big_file_upload";
import {isRequired, /*isRequired, */minValue, required} from "../field_validations";
import {confirmAlert} from "react-confirm-alert";
import Loading from "../loading";
import DatePick from "../forms/datepicker";

export default class Expenses extends Component {
	render(){
		const {reports, match} = this.props;
		const {expenses} = reports;
		const {revision} =expenses;
		const {modality} = match.params;
		let ec = _.find(reports.permissions, (o) => o === 'Create') ? true:false;
		return(
			<div className="columns is-centered">
				{this.state.modalExpenseShow ? <ModalExpensesInvoices active={this.state.modalExpenseShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
				<div className="column">
					<table className="inm-table" style={{fontSize: '.85em'}}>
						<thead>
						<tr>
							<th>No.</th>
							<th>Concepto del gasto</th>
							<th>Unidad de medida</th>
							<th>Costo unitario</th>
							<th>Cantidad</th>
							<th>Monto ejercido</th>
						</tr>
						</thead>
						<tbody>
						{_.map(expenses.data.project_expenses,(row,k) => {
							let revisionExpenses = !_.isEmpty(revision.body) ? revision.body:undefined;
							let expRevision = revisionExpenses && !_.isEmpty(revisionExpenses[row.id]) ? revisionExpenses[row.id]: undefined
							let expRevisionAllowEdit = expRevision && !_.isEmpty(expRevision.allow_edit) ? (expRevision.allow_edit === 'true' ? true:false):undefined;
							let validEditExp = ec ? (revisionExpenses && expRevisionAllowEdit !== undefined  ? expRevisionAllowEdit:(revisionExpenses && expRevisionAllowEdit === undefined ? false:ec)):false;
							return [
								<tr key={k}>
									<td style={{width: 10 + '%'}} rowSpan={revisionExpenses && expRevision && expRevision.comment ? 2:1}>
										<span>{k + 1}</span>
									</td>
									<td style={{width: 30 + '%'}}>{row.expense_concept ? row.expense_concept.name:'---'}</td>
									<td>
										<strong>{row.expense_unit ? row.expense_unit.name:'---'}</strong><br/>
										{!row.expense_unit.invoiceable ?
											<strong className={`has-text-danger`}>No facturable</strong>
											:''}
									</td>
									<td className="has-text-right" style={{width: 10 + '%'}}>{formatMoney(row.amount ? row.amount:0)}</td>
									<td className="has-text-centered">{row.quantity}</td>
									<td style={{width: 15 + '%', padding: '1em .5em 1em 30px'}}>
										{this.state.modalMessageExpensesShow && k === this.state.expenseIndex ?
											<ModalMessageExpenses active={this.state.modalMessageExpensesShow} unit={row.expense_unit} amountTotal={row.total} data={row.project_version_phase_expense} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
										<div className="actions">
											<button type="button" style={{cursor: 'pointer'}} onClick={() => this._showMessageExpenses(k)}><i className="fa fa-eye"></i></button>
											{validEditExp ?
												<button type="button" style={{cursor: 'pointer'}} onClick={() => this._editExpenseDocuments(row.id, k, row.project_version_phase_expense, expenses.data.agencies, row.expense_unit)}><i className="fa fa-edit"></i></button>
												:''}
										</div>
										<p className="has-text-inm-purple">Monto ejercido</p>
										{formatMoney(row.project_version_phase_expense && row.project_version_phase_expense.amounts ? row.project_version_phase_expense.amounts.spent_total:0)}
										<p className="has-text-inm-purple">Monto por ejercer</p>
										{formatMoney(row.project_version_phase_expense && row.project_version_phase_expense.amounts ? row.project_version_phase_expense.amounts.missing:row.total)}
									</td>
								</tr>,
								expRevision && expRevision.comment ?
								<tr key={`exp-rev-${k}`}>
									<td colSpan={5}>
										<div className={`notification ${expRevision.status ? `is-${expRevision.status}`:''}`}>
											<i className="fa fa-info"/>&nbsp;
											{expRevision.comment}
										</div>
										{modality === 'modalidad-iii' ?
											_.map(expenses.data.agencies, (rev,o) => {
												let expenseRevisionCdm = revisionExpenses && !_.isEmpty(revisionExpenses[row.id]) && !_.isEmpty(revisionExpenses[row.id].agencies) && !_.isEmpty(revisionExpenses[row.id].agencies[rev.id]) ? revisionExpenses[row.id].agencies[rev.id]: undefined
												if(expenseRevisionCdm && expenseRevisionCdm.comment){
													return (
														<div key={o}>
															<span className="help is-dark">{`Revisión del gasto No. ${k+1} por CDM - ${rev.agenciable.name}`}</span>
															<div className={`notification ${expenseRevisionCdm.status ? `is-${expenseRevisionCdm.status}`:''}`}>
																<i className="fa fa-info"/>&nbsp;
																{expenseRevisionCdm.comment}
															</div>
														</div>
													)
												}
											})
											:''}
									</td>
								</tr>
								:null
							]
						})}
						<tr>
							<td colSpan={6} className="has-text-centered" style={{ backgroundColor: '#a864a9'}}>
								<strong style={{color: '#fff'}}>Total Aprobado / Ejercido / Por ejercer&nbsp;{`              ${formatMoney(!_.isEmpty(expenses.data) ? expenses.data.amounts.expenses.total:0)} / ${formatMoney(!_.isEmpty(expenses.data) ? expenses.data.amounts.expenses.spent:0)} / ${formatMoney(!_.isEmpty(expenses.data) ? expenses.data.amounts.expenses.missing:0)}`}</strong>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state = {
			modalExpenseShow:false,
			expenseIndex: undefined,
			modalMessageExpensesShow: false
		}
	}

	_editExpenseDocuments(id, indexExpense, versionPhaseGoal, agencies, unit) {
		this.props.reset('reports.expenses.edit');

		if(!_.isEmpty(versionPhaseGoal)){
			this.props.change(`reports.expenses.edit`, {
				...versionPhaseGoal,
				indexExpense: indexExpense,
				agencies: agencies,
				invoiceable: unit.invoiceable,
				unit_name: unit.name
			});
		}else {
			this.props.change('reports.expenses.edit', {
				project_expense_id: id,
				indexExpense: indexExpense,
				agencies: agencies,
				invoiceable: unit.invoiceable,
				unit_name: unit.name
			});
		}

		this.setState({
			modalExpenseShow: true,
			expenseIndex: indexExpense
		})
	}

	_showMessageExpenses(indexExpense){
		this.setState({
			modalMessageExpensesShow: true,
			expenseIndex: indexExpense
		})
	}

	_toggleModal() {
		this.setState({
			modalExpenseShow: false,
			modalMessageExpensesShow: false
		});

		this.props.reset('reports.expenses.edit');
	}
}

class ModalExpensesInvoices extends Component {
	render() {
		let { reports, match, revision } = this.props;
		let { expenses } = reports;
		let totalCdms = 0;
		let revisionExpenses = !_.isEmpty(revision.body) ? revision.body:undefined;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-card">
					<header className="modal-card-head">
						<p className="modal-card-title">Gastos de coordinación</p>
						<button type="button" onClick={this.props.closeModal} className="delete"
						        aria-label="close"></button>
					</header>
					<div className="modal-card-body">
						{expenses.edit.isFetching ? <Loading/>:
						<Form model="reports.expenses.edit" onSubmit={(values) => this._submitForm(values)}>
							<div className="columns">
								<div className="column">
									<div className="level">
										<div className="level-left">
											<div className="level-item"><h5 className="title is-5">{`${expenses.edit.unit_name}`}</h5></div>
											{expenses.edit.invoiceable ? '':<div className="level-item"><strong className={`has-text-danger`}>No facturable</strong></div>}
										</div>
									</div>

									<fieldset className="fieldset">
										<legend>AGREGAR CFDI</legend>

										{expenses.edit.invoiceable ?
											<div className="field is-grouped">
												<BigFileUpload
													model=".pdf"
													name="PDF"
													file={expenses.edit.pdf}
													size="small"
													validators={{required}}
													message={{required: 'Falta anexar PDF'}}
												/>

												<BigFileUpload
													model=".xml"
													name="XML"
													file={expenses.edit.xml}
													size="small"
													validators={{required}}
													message={{required: 'Falta anexar XML'}}
												/>

												<BigFileUpload
													model=".sat"
													name="Validación SAT"
													file={expenses.edit.sat}
													size="small"
													validators={{required}}
													message={{required: 'Falta anexar Validación'}}
												/>
											</div>
											:<div>
												<div className="field">
													<BigFileUpload
														model=".file"
														name="Comprobante"
														file={expenses.edit.file}
														size="small"
														validators={{required}}
														message={{required: 'Falta anexar Comprobante'}}
													/>
												</div>

												<div className="field is-grouped is-grouped-multiline">
													<div className="control">
														<div className="field">
															<label htmlFor="amount" className="label">Monto <span className="small has-text-danger">*</span></label>
															<div className="control has-icons-left">
																<Control.text
																	model=".total"
																	id="total"
																	className="input"
																	type="number" step=".01" min="0"
																	errors={{isRequired, minValue: minValue(0)}}
																	validateOn="change"/>
																<span className="icon is-small is-left"><i className="fa fa-usd"/></span>
															</div>
														</div>
														<Errors
															model=".total"
															show="touched"
															wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>}
															messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
													</div>

													<div className="control">
														<label htmlFor="date" className="label">Fecha de recibo <span className="small has-text-danger">*</span></label>
														<Control
															model=".date"
															className="input"
															errors={{isRequired}}
															validateOn="change"
															id="date"
															component={DatePick}
														/>
														<Errors
															model=".date"
															show="touched"
															wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
															messages={{isRequired: 'La fecha es obligatoria'}}
														/>
													</div>
												</div>

												<div className="field">
													<div className="control">
														<label htmlFor="" className="label">Concepto <span className="small has-text-danger">*</span></label>
														<Control.textarea
															model=".concepts"
															id="concepts"
															className="textarea"
															errors={{isRequired}}
															validateOn="change"/>
														<Errors
															model=".concepts"
															show="touched"
															wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
															messages={{isRequired: 'El concepto es obligatorio'}}
														/>
													</div>
												</div>
											</div>}



									</fieldset>

									{match.params.modality === 'modalidad-iii' ?
										<fieldset className="fieldset">
											<legend>DESGLOSE POR CDM</legend>
											<p>Indica el monto gastado en cada instancia. Recuerda que el total debe ser igual al monto de la factura cargada.</p>
											<div className="field is-grouped is-grouped-multiline">
												{_.map(expenses.edit.agencies, (item, key) => {
													totalCdms += expenses.edit.agencies[key].amount ? _.toNumber(expenses.edit.agencies[key].amount):0;
													let expenseRevisionCdm = revisionExpenses && !_.isEmpty(revisionExpenses[expenses.edit.project_expense_id]) && !_.isEmpty(revisionExpenses[expenses.edit.project_expense_id].agencies) && !_.isEmpty(revisionExpenses[expenses.edit.project_expense_id].agencies[item.id]) ? revisionExpenses[expenses.edit.project_expense_id].agencies[item.id]: undefined
													return (
														<div className="control" key={key}>
															{expenseRevisionCdm && expenseRevisionCdm.comment ? <p className={`field-notification is-${expenseRevisionCdm.status}`}>{expenseRevisionCdm.comment}</p>:''}
															<div className="field">
																<label htmlFor={`agencies_amount_${key}`} className="label">{item.agenciable.name} <span className="small has-text-danger">*</span></label>
																<div className="control has-icons-left">
																	<Control.text model={`.agencies[${key}].amount`} id={`agencies_amount_${key}`} className={`input${expenseRevisionCdm ? ` is-${expenseRevisionCdm.status}`:''}`} type="number" step=".01" min="0" errors={{minValue: minValue(0)}} validateOn="change"/>
																	<span className="icon is-small is-left"><i className="fa fa-usd"/></span>
																	<Errors model={`.agencies[${key}].amount`} show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Se requiere una cantidad',minValue: 'Cantidad minima no admitida.'}} />
																</div>
															</div>
														</div>
													)
												})}
											</div>
											<div className="field is-grouped is-grouped-right">
												<div className="control">
													<p className="is-size-5"><strong>Total:</strong>&nbsp;{formatMoney(totalCdms)}</p>
													{totalCdms > 0 ? '':<small className="help has-text-danger">Se requiere una cantidad</small>}
												</div>
											</div>
										</fieldset>
										:''}

									{!_.isEmpty(expenses.edit.invoices) ?
										<fieldset className="fieldset">
											<legend>Facturas</legend>
											<table className="inm-table">
												<thead>
												<tr>
													<th>Factura</th>
													<th>PDF</th>
													<th>XML</th>
													<th>SAT</th>
													<th>Accion</th>
												</tr>
												</thead>
												<tbody>
												{_.map(expenses.edit.invoices, (item,k) => {
													return(
														<tr key={k}>
															<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

															<td>
																<div className="control">
																	<a href={item.pdf}  className="button is-info" target="_blank">
																		<span className="icon"><i className="fa fa-eye"/></span>
																	</a>
																</div>
															</td>

															<td>
																<div className="control">
																	<a href={item.xml}  className="button is-info" target="_blank">
																		<span className="icon"><i className="fa fa-eye"/></span>
																	</a>
																</div>
															</td>

															<td>
																<div className="control">
																	<a href={item.sat}  className="button is-info" target="_blank">
																		<span className="icon"><i className="fa fa-eye"/></span>
																	</a>
																</div>
															</td>

															<td>
																<div className="control">
																	<div className="button is-danger" onClick={() => this._getConfirm(k, expenses.edit.invoiceable)} disabled={expenses.data.editable ? false:true}>
																		<span className="icon"><i className="fa fa-trash-o"/></span>
																	</div>
																</div>
															</td>
														</tr>
													)
												})}
												</tbody>
											</table>
										</fieldset>
										:''}

									{!_.isEmpty(expenses.edit.receipts) ?
										<fieldset className="fieldset">
											<legend>Comprobantes</legend>
											<table className="inm-table">
												<thead>
												<tr>
													<th>Comprobante</th>
													<th>Archivo</th>
													<th>Concepto</th>
												</tr>
												</thead>
												<tbody>
												{_.map(expenses.edit.receipts, (item,k) => {
													return(
														<tr key={k}>
															<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

															<td>
																<div className="control">
																	<a href={item.file}  className="button is-info" target="_blank">
																		<span className="icon"><i className="fa fa-eye"/></span>
																	</a>
																</div>
															</td>

															<td>{item.concepts}</td>

															<td>
																<div className="control">
																	<div className="button is-danger" onClick={() => this._getConfirm(k, expenses.edit.invoiceable)} disabled={expenses.data.editable ? false:true}>
																		<span className="icon"><i className="fa fa-trash-o"/></span>
																	</div>
																</div>
															</td>
														</tr>
													)
												})}
												</tbody>
											</table>
										</fieldset>
										:''}

									<div className="field is-grouped is-grouped-right">
										<div className="control">
											<button type="button" className="button is-danger"
											        onClick={this.props.closeModal}>Cerrar
											</button>
										</div>
										<div className="control">
											<Control.button model="reports.expenses.edit" className="button is-success"
											                disabled={this._validSubmit(totalCdms)}>
												Guardar
											</Control.button>
										</div>
									</div>
								</div>
							</div>
						</Form>}
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span
							className="small has-text-danger">*</span> son obligatorios.</p>
					</div>
				</div>
			</div>
		)
	}

	componentWillReceiveProps(newprops){
		let {edit} = newprops.reports.expenses;
		if(edit !== this.props.reports.expenses.edit){
			if(edit.action){
				if(edit.action === 'close'){
					this.props.closeModal();
					this.props.change('reports.expenses.edit.action', undefined);
				}else if(edit.action === 'delete' && _.isEmpty(edit.invoices)){
					this.props.closeModal();
					this.props.change('reports.expenses.edit.action', undefined);
				}
			}
		}

	}

	_getConfirm(index, invoiceable){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar ${invoiceable ? 'la factura':'el comprobante'}?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => {
				if(invoiceable){
					this._removeInvoice(index)
				}else {
					this._removeReceipts(index)
				}
			}
		})
	}

	_removeInvoice(index){
		let {expenses} = this.props.reports;
		let { modality, state, municipality } = this.props.match.params;

		if(!_.isObject(expenses.edit.invoices[index])){
			this.props.remove('reports.expenses.edit.invoices', index);
		}else {
			this.props.expensesInvoiceDelete(expenses.edit, expenses.edit.invoices[index].id,modality, state, municipality)
		}
	}

	_removeReceipts(index){
		let {expenses} = this.props.reports;
		let { modality, state, municipality } = this.props.match.params;

		if(!_.isObject(expenses.edit.receipts[index])){
			this.props.remove('reports.expenses.edit.receipts', index);
		}else {
			this.props.expensesReceiptDelete(expenses.edit, expenses.edit.receipts[index].id,modality, state, municipality)
		}
	}

	_submitForm(values) {
		let { expenses } = this.props.reports;
		let { modality, state, municipality } = this.props.match.params;

		if(expenses.edit.invoiceable){
			this.props.expenseInvoicesSave(modality, state, municipality, values);
		}else {
			this.props.expenseReceiptsSave(modality, state, municipality, values);
		}
	}

	_validSubmit(totalCdms){
		let {modality} = this.props.match.params;
		let {expenses} = this.props.reports;
		let valid = false;

		if(expenses.data.editable){
			if(modality !== 'modalidad-iii'){
				valid = false;
			}else {
				if(totalCdms>0){
					valid = false;
				}else {
					valid = true;
				}
			}
		}else {
			valid = true;
		}
		return valid;
	}
}

class ModalMessageExpenses extends Component {
	render(){
		let { data, amountTotal, unit } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: (!_.isEmpty(data) && _.isEmpty(data.invoices)) || (_.isEmpty(data)) ? 'auto':''}}>
					<div className="message">
						<div className="message-header">
							<p>Gastos de coordinación</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<h5 className="title is-5">{`${unit.name}${unit.invoiceable ? '':' - No facturable'}`}</h5>

							<div className="columns">
								<div className="column is-6">
									<p>Monto aprobado</p>
									<p><strong>{formatMoney(amountTotal)}</strong></p>
								</div>
								<div className="column is-6">
									<p>Monto ejercido</p>
									<p><strong>{formatMoney(data && data.amounts && !isNaN(data.amounts.spent_total) ? data.amounts.spent_total:0)}</strong></p>
								</div>
							</div>

							<div className="columns">
								<div className="column is-6">
									<p>Monto por ejercer</p>
									<p><strong>{formatMoney(data && data.amounts && !isNaN(data.amounts.missing) ? data.amounts.missing : amountTotal)}</strong></p>
								</div>
							</div>

							{!_.isEmpty(data) && !_.isEmpty(data.invoices) ?
								<fieldset className="fieldset">
									<legend>Facturas</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Factura</th>
											<th>PDF</th>
											<th>XML</th>
											<th>SAT</th>
										</tr>
										</thead>
										<tbody>
										{_.map(data.invoices, (item,k) => {
											return(
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.pdf}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.xml}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.sat}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</fieldset>
								:''}

							{!_.isEmpty(data) && !_.isEmpty(data.receipts) ?
								<fieldset className="fieldset">
									<legend>Comprobantes</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Comprobante</th>
											<th>Archivo</th>
											<th>Concepto</th>
										</tr>
										</thead>
										<tbody>
										{_.map(data.receipts, (item,k) => {
											return(
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.file}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>{item.concepts}</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</fieldset>
								:''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/elements/reports/expenses.jsx